"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultLegacyInsightMenuItems = void 0;
/**
 * @internal
 */
function getDefaultLegacyInsightMenuItems(intl, config) {
    var exportCSVDisabled = config.exportCSVDisabled, exportXLSXDisabled = config.exportXLSXDisabled, onExportCSV = config.onExportCSV, onExportXLSX = config.onExportXLSX, isDataError = config.isDataError;
    var tooltip = isDataError
        ? intl.formatMessage({ id: "options.menu.unsupported.error" })
        : intl.formatMessage({ id: "options.menu.unsupported.loading" });
    return [
        {
            type: "button",
            itemId: "ExportXLSXBubble",
            itemName: intl.formatMessage({ id: "options.menu.export.XLSX" }),
            disabled: exportXLSXDisabled,
            onClick: onExportXLSX,
            tooltip: tooltip,
            className: "options-menu-export-xlsx s-options-menu-export-xlsx",
        },
        {
            type: "button",
            itemId: "ExportCSVBubble",
            itemName: intl.formatMessage({ id: "options.menu.export.CSV" }),
            disabled: exportCSVDisabled,
            onClick: onExportCSV,
            tooltip: tooltip,
            className: "options-menu-export-csv s-options-menu-export-csv",
        },
    ];
}
exports.getDefaultLegacyInsightMenuItems = getDefaultLegacyInsightMenuItems;
//# sourceMappingURL=getDefaultLegacyInsightMenuItems.js.map